module.exports = __webpack_public_path__ + "img/left_hand.png";